import { Link } from 'react-router-dom';
import logoImg from '../logo192.png';

export const AppHeaderTitle = () => {
  return (
    <div style={{ display: 'inline-block' }}>
      <Link
        to="/"
        style={{
          color: 'inherit',
          textDecoration: 'inherit',
        }}
      >
        <span title="xBook" className="h1">
          <img
            src={logoImg}
            alt="xBook logo"
            style={{ verticalAlign: 'bottom', height: '3rem' }}
          />
          <span className="ms-2">xBook</span>
        </span>
      </Link>
      {/* <span className="text-muted ms-2">
        <Beta />
      </span> */}
      <span className="text-muted ms-2 d-none d-sm-inline">
        <span style={{ fontWeight: 300 }}>
          healthy online community & games
        </span>
      </span>
    </div>
  );
};
